// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1uJVx","content":"GlobalSearch_content__1PQdz"};